import * as api from 'api/recipe/PostRecipeSearchV1';
import TagCategory from 'classes/Recipe/Search/TagCategory';
import * as Icon from 'types/Icon/Icon';

export default class Tag {
	id: string = '';
	iconSvgUrl: string = '';
	display: boolean = false;
	name: string = '';
	tagCategory: TagCategory = new TagCategory();

	public constructor(input?: api.Tag) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public mapToIcon(): Icon.Type | null {
		if (this.display) {
			return {
				name: this.name,
				iconSvgUrl: this.iconSvgUrl,
			};
		}
		return null;
	}

	public mapFromApi(input: api.Tag): void {
		this.id = input.id;
		this.iconSvgUrl = input.iconSvgUrl ?? '';
		this.display = input.display;
		this.name = input.name ?? '';
		this.tagCategory.mapFromApi(input.tagCategory);
	}
}
